import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import filterSampleListOnMatchers from '@avtechsoftware/ra-javascript-utilities/src/utilities/samples/SampleUtility';
import { useSelector } from 'react-redux';
import RemoteService from '@avtechsoftware/ra-javascript-utilities/src/utilities/remoteService/remoteService';
import quickAlertImg from '../../../../../RAA_AlertingImage_221206_RedAccent.png';
import RaaDefaultButton from '../../../../common/RaaDefaultButton/RaaDefaultButton';
import envConfig from '../../../../../envConfig';
import styles from './EmptyAlertListMessage.module.css';
import { selectSessionInformation } from '../../../../../redux/slices/sessionSlice';
import { sessionHash } from '../../../../../utility/remoteServiceUtil';
import { selectRoomAlertDeviceList } from '../../../../../redux/slices/deviceList/deviceListSlice';

function EmptyAlertListMessage() {
  const history = useHistory();
  const deviceList = useSelector(selectRoomAlertDeviceList);
  const { activeSubscription } = useSelector(selectSessionInformation);
  const [samples, setSamples] = useState({});
  const alertLimit = activeSubscription.activeTierAlertLimit;
  const hasAdvancedAlerting = activeSubscription.activeTierHasAdvancedAlerting;
  const availableDeviceList = deviceList.filter((device) => device.type !== 'RAMAX' && device.type !== 'VIRT' && device.type !== 'CONNECT');
  const devices = availableDeviceList.filter((device) => !device.isSuspended);
  const disableCreateAlert = !devices.length > 0 || !Object.keys(samples).length > 0;

  const isUnlimited = Number(alertLimit) === 1000000;
  const maxAlerts = isUnlimited ? 'unlimited' : alertLimit;

  React.useEffect(() => {
    const getSampleList = () => RemoteService
      .get({
        url: `${envConfig.apiUrl}/api/v1/device-data/latest-samples?auth_token=${sessionHash}`,
        nonBearerAuthToken: sessionHash,
      })
      .then((responseData) => {
        const { sampleList } = responseData;
        setSamples(filterSampleListOnMatchers(sampleList, ['*_16_*_*_*_*', '*_38_*_*_*_*']));
      }).catch(() => {
        setSamples({});
      });
    getSampleList();
  }, []);

  return (
    <>
      <div className="clearfix mt-5 mb-3">
        <h4 className="float-left">Quick Alert</h4>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="offset-sm-2 col-sm-8">
              <h5 className="card-title">
                You don&apos;t have any alerts yet!
              </h5>
              <hr />
              <div className="row my-3">
                <div className="col-12">
                  <p>
                    Your account level gives you access to
                    {' '}
                    {alertLimit > 1 ? `${maxAlerts} alerts` : `${maxAlerts} alert`}
                    {
                      hasAdvancedAlerting === true ? (
                        <>
                          {' '}
                          with
                          {' '}
                          <a
                            href="https://avtech.com/articles/5508/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            advanced alerting features.
                          </a>
                        </>
                      )
                        : (
                          '.'
                        )
                    }

                  </p>
                  <p>
                    Room Alert Account can automatically set up some alerts for you. Select
                    {' '}
                    <b>Quick Setup</b>
                    {' '}
                    to get started.
                  </p>
                </div>
              </div>
              <div className="my-3 row justify-content-center text-center">
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-primary mr-4"
                    disabled={disableCreateAlert}
                    onClick={() => history.push('/s/alerts/quick')}
                  >
                    Quick Setup
                  </button>
                  <RaaDefaultButton
                    disabled={disableCreateAlert}
                    onClick={() => history.push('/s/alerts/new')}
                  >
                    Advanced Setup
                  </RaaDefaultButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          className={`${styles.quickAlertCardImg} card-img-bottom px-3 pb-3`}
          src={quickAlertImg}
          alt="quick-alert-bg-img"
        />
      </div>
    </>
  );
}
export default EmptyAlertListMessage;
